module.exports = __webpack_public_path__ + "media/images/Group 11-af0f516ae61c0860fbc316ea5e254864.png";